var map = {
	"./404.svg": "sEM+",
	"./articleEdit.svg": "JiR+",
	"./banner.svg": "DXJQ",
	"./bug.svg": "SVqS",
	"./build.svg": "HZxw",
	"./cfg.svg": "cwkd",
	"./channel.svg": "5e3z",
	"./chart.svg": "RjYk",
	"./clipboard.svg": "KO/S",
	"./code.svg": "IX5Q",
	"./component.svg": "s2cW",
	"./contacts.svg": "7bQR",
	"./dashboard.svg": "BCGP",
	"./date.svg": "Ve8B",
	"./dept.svg": "ynRI",
	"./dict.svg": "OyZ9",
	"./documentation.svg": "zUKd",
	"./download.svg": "+H2/",
	"./drag.svg": "vRhf",
	"./druid.svg": "yII6",
	"./edit.svg": "ql+d",
	"./education.svg": "wyC6",
	"./email.svg": "+4G4",
	"./excel.svg": "OLl3",
	"./exit-fullscreen.svg": "G+/G",
	"./eye-open.svg": "no6o",
	"./file.svg": "fQ0v",
	"./form.svg": "sTIr",
	"./fullscreen.svg": "WIff",
	"./icon.svg": "vUvT",
	"./international.svg": "SBEl",
	"./job.svg": "sieq",
	"./language.svg": "+Dip",
	"./link.svg": "KgwQ",
	"./list.svg": "vuHp",
	"./lock.svg": "FnAU",
	"./log.svg": "8uFK",
	"./logininfor.svg": "htrW",
	"./menu.svg": "dH9r",
	"./message.svg": "G2zY",
	"./money.svg": "ig9B",
	"./monitor.svg": "Lu+8",
	"./nested.svg": "798r",
	"./nested0.svg": "9Ylh",
	"./online.svg": "lWBX",
	"./operation.svg": "Dh6m",
	"./password.svg": "QjmH",
	"./password0.svg": "8LDd",
	"./pdf.svg": "M8Oc",
	"./people.svg": "GPe0",
	"./peoples.svg": "TgHK",
	"./phone.svg": "7pRf",
	"./post.svg": "6LpI",
	"./qq.svg": "R2jY",
	"./search.svg": "Bx0U",
	"./sender.svg": "kQcg",
	"./server.svg": "2Sb8",
	"./shopping.svg": "jRi0",
	"./shoppingCard.svg": "dNDk",
	"./size.svg": "Cr4N",
	"./skill.svg": "NpjO",
	"./star.svg": "60zo",
	"./swagger.svg": "u+kp",
	"./system.svg": "Jax1",
	"./tab.svg": "Jysk",
	"./table.svg": "oSYw",
	"./table0.svg": "peD6",
	"./task.svg": "EK3d",
	"./template.svg": "//Qc",
	"./theme.svg": "hdtf",
	"./tool.svg": "Y44e",
	"./tree-table.svg": "myHh",
	"./tree.svg": "3eCm",
	"./user.svg": "VdD3",
	"./user0.svg": "ntyw",
	"./validCode.svg": "5eKK",
	"./wechat.svg": "pYJ+",
	"./zip.svg": "0DNV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 72